/** 판매 관리 - 프리미엄 패스 */

import { ADMIN, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

export const premiumpassApi = {
  read: () =>
    ifyouApi
      .get(`${ADMIN}/timedeal-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  update: (inputData) =>
    ifyouApi
      .post(`${ADMIN}/timedeal-update`, {
        // 신규 : 0
        timedeal_id: inputData.timedeal_id,
        conditions: inputData.conditions,
        discount: inputData.discount,
        deadline: inputData.deadline,
        episode_progress: inputData.episode_progress,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  delete: (timedealId) =>
    ifyouApi
      .post(`${ADMIN}/timedeal-delete`, {
        timedeal_id: timedealId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  /////////////////////
  premiumList: () =>
    ifyouApi
      .get(`${ADMIN}/timedeal-list`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  registerPremium: (inputData) =>
    ifyouApi
      .post(`${ADMIN}/timedeal-update`, {
        // 신규 : 0
        timedeal_id: inputData.timedeal_id,
        conditions: inputData.conditions,
        discount: inputData.discount,
        deadline: inputData.deadline,
        episode_progress: inputData.episode_progress,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),

  deletePremium: (timedealId) =>
    ifyouApi
      .post(`${ADMIN}/timedeal-delete`, {
        timedeal_id: timedealId,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};

/// 프리패스 리스트 출력
export const getPremiumpassList = async () => {
  try {
    const res = await ifyouApi.get(`${ADMIN}/timedeal-list`);
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

/// 프리미엄 패스 신규 등록 & 수정
export const registerPremium = async (inputData) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/timedeal-update`, {
      // 신규 : 0
      timedeal_id: inputData.timedeal_id,
      conditions: inputData.conditions,
      discount: inputData.discount,
      deadline: inputData.deadline,
      episode_progress: inputData.episode_progress,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};

/// 프리미엄 패스 삭제
export const deletePremium = async (timedealId) => {
  try {
    const res = await ifyouApi.post(`${ADMIN}/timedeal-delete`, {
      timedeal_id: timedealId,
    });
    return res.data;
  } catch (error) {
    if (error.response) {
      ErrorMessage(error.response.status, error.response.data);
    }
  }
};
